import Base from 'app/views/base';

import { showError } from 'utils/messages';
import { formatIsoDateTime } from 'utils/dates';

import tmpl from 'templates/webhook_list_item';
import WebhookDeleteModal from 'app/views/modals/webhook_delete_modal';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click a.delete': 'showDeleteModal',
    'click a.enable': 'enable',
  },

  initialize() {
    this.deleteModal = new WebhookDeleteModal({
      model: this.model,
      collection: this.collection,
    });
  },

  context() {
    let disabled;
    if (this.model.get('disabled_at')) {
      disabled = formatIsoDateTime(this.model.get('disabled_at'));
    } else {
      disabled = undefined;
    }

    return {
      id: this.model.id,
      url: this.model.get('url'),
      disabled_at: disabled,
    };
  },

  showDeleteModal(event) {
    event.preventDefault();
    this.deleteModal.show();
  },

  enable(event) {
    const self = this;
    event.preventDefault();
    this.model.update({}, {
      success() {
        self.render();
      },
      error() {
        showError('The webhook could not be enabled. Please try again later');
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/webhook_list_item_view.js